export default __webpack_public_path__ + "static/media/s1-icon-1.ed965044.svg";